module.exports = {
  // 请求超时时间
  timeout: 30000,
  // 错误码
  RESPONSE_CODE: {
    400: '请求参数错误',
    403: '拒绝访问',
    404: '请求超时',
    500: '服务器内部错误',
    501: '服务未实现',
    502: '网关错误',
    503: '服务不可用',
    504: '网关超时',
    505: 'HTTP版本不受支持',
  },

  testBaseUrl: {
    http: 'https://userdev.topwealthgroup.com/',
    payhttp: 'https://paydev.topwealthgroup.com/',
    tradehttp: 'https://tradedev.topwealthgroup.com/',
    stradehttp: 'https://stradedev.topwealthgroup.com/',
    hqhttp: 'https://hqdev.topwealthgroup.com/',
    newshttp: 'https://newsdev.topwealthgroup.com/',
    activityhttp: 'https://activitydev.topwealthgroup.com/'
  },
  masterBaseUrl: {
    http: 'https://user.topwealthgroup.com/',
    payhttp: 'https://pay.topwealthgroup.com',
    tradehttp: 'https://trade.topwealthgroup.com/',
    stradehttp: 'https://strade.topwealthgroup.com/',
    hqhttp: 'https://hq.topwealthgroup.com/',
    newshttp: 'https://news.topwealthgroup.com/',
    activityhttp: 'https://activity.topwealthgroup.com/',
  },
  // 代理的URL
  proxyUrl: '', 
  // 加密信息
  key: 'b1d958e55733495e',
  iv: '9ad37037',
  // token 后期可更换名称
  TOKEN_KEY: 'token',
};
